<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 33.629 29.621">
        <g id="Group_2824" data-name="Group 2824" transform="translate(-24 -675)">
            <circle id="Ellipse_193" data-name="Ellipse 193" cx="14" cy="14" r="14" transform="translate(24 675)"
                    fill="#cedbff"/>
            <g id="logout" transform="translate(32.387 679.371)">
                <path id="Path_70009" data-name="Path 70009"
                      d="M288.112,209.586h-9.991a.789.789,0,0,1,0-1.578h9.991a.789.789,0,0,1,0,1.578Zm0,0"
                      transform="translate(-263.66 -197.746)" fill="#799cfb"/>
                <path id="Path_70010" data-name="Path 70010"
                      d="M400.793,137.437a.789.789,0,0,1-.558-1.347l3.387-3.386-3.387-3.387a.789.789,0,1,1,1.116-1.116l3.944,3.944a.789.789,0,0,1,0,1.116l-3.944,3.944A.784.784,0,0,1,400.793,137.437Zm0,0"
                      transform="translate(-380.284 -121.653)" fill="#799cfb"/>
                <path id="Path_70011" data-name="Path 70011"
                      d="M8.414,25.249a2.167,2.167,0,0,1-.652-.1L1.432,23.043a2.123,2.123,0,0,1-1.432-2V2.112A2.106,2.106,0,0,1,2.1.008a2.169,2.169,0,0,1,.652.1L9.085,2.215a2.123,2.123,0,0,1,1.432,2V23.146a2.105,2.105,0,0,1-2.1,2.1ZM2.1,1.586a.527.527,0,0,0-.526.526V21.043a.547.547,0,0,0,.365.507l6.3,2.1a.571.571,0,0,0,.172.023.527.527,0,0,0,.526-.526V4.215a.547.547,0,0,0-.365-.507l-6.3-2.1A.571.571,0,0,0,2.1,1.586Zm0,0"
                      transform="translate(0 0)" fill="#799cfb"/>
                <path id="Path_70012" data-name="Path 70012"
                      d="M41.392,8.422a.789.789,0,0,1-.789-.789V2.9a1.316,1.316,0,0,0-1.315-1.315H27.457a.789.789,0,0,1,0-1.578H39.289A2.9,2.9,0,0,1,42.181,2.9V7.633A.789.789,0,0,1,41.392,8.422Zm0,0"
                      transform="translate(-25.353)" fill="#799cfb"/>
                <path id="Path_70013" data-name="Path 70013"
                      d="M186.328,285.754h-4.207a.789.789,0,0,1,0-1.578h4.207a1.316,1.316,0,0,0,1.315-1.315v-4.733a.789.789,0,0,1,1.578,0v4.733A2.9,2.9,0,0,1,186.328,285.754Zm0,0"
                      transform="translate(-172.393 -263.66)" fill="#799cfb"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "ILogout",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
